import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import {
  ModalCard,
  ModalFooter,
  useCreateModal,
} from 'partial/components/Modal';
import FormTextArea from 'partial/components/form/FormTextArea';

import Button from 'partial/components/Button';
import { useUpdateMaskName } from '../hooks';

export const useOpenUpdateMaskName = () => {
  const createModal = useCreateModal();

  const openUpdateMaskNameModal = useCallback(
    (data) => {
      createModal({
        content: (close) => <UpdateMaskName data={data} onClose={close} />,
      });
    },
    [createModal],
  );

  return openUpdateMaskNameModal;
};

const status = {
  approve: 'APPROVED',
  reject: 'REJECTED',
};

function UpdateMaskName({ onClose, data }) {
  const [remarks, setRemarks] = useState('');
  const [isLoading, update] = useUpdateMaskName({
    onSuccess: onClose,
    onError: onClose,
  });
  const isApprove = data?.action === 'approve';

  const submit = () => {
    update({
      uuid: data?.uuid,
      payload: { status: status?.[data?.action], remarks },
    });
  };

  const isDisabled = useMemo(
    () => (isApprove ? false : remarks.length === 0),
    [isApprove, remarks],
  );

  return (
    <ModalCard
      size="sm"
      title={
        isApprove ? 'Approve this mask name?' : 'Disapprove this mask name?'
      }
      onClose={onClose}
    >
      <div className="px-5 py-4 w-full space-y-4">
        <p className="text-sm text-neutral-700">
          <span className="font-semibold text-neutral-900">{data?.name}</span>{' '}
          will be {isApprove ? 'approved' : 'disapproved'}.
        </p>
        {!isApprove && (
          <FormTextArea
            name="remarks"
            onSetFieldValue={(_, value) => setRemarks(value)}
            value={remarks}
            label="Reason for disapproval"
            required
          />
        )}
      </div>
      <ModalFooter>
        <Button secondary onClick={onClose}>
          Cancel
        </Button>
        <Button
          primary={isApprove}
          danger={!isApprove}
          disabled={isDisabled}
          isLoading={isLoading}
          onClick={submit}
        >
          {isApprove ? 'Approve' : 'Disapprove'}
        </Button>
      </ModalFooter>
    </ModalCard>
  );
}

UpdateMaskName.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default UpdateMaskName;
